export default class Contact {
  fullName: string | null = "";
  email: string | null = "";
  jobTitle: string | null = "";
}
